import { ComponentIds, Entity } from '@inter-ikea-core/core';
import { CommunicationSizeComponent } from '@inter-ikea-core/core';
import { Product, ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';
import { getMarketProducts } from 'ducks/products';
import store from 'ducks/configureStore';

const getEntitySizeString = (entity: Entity) => {
  const entitySize = entity.getComponent<CommunicationSizeComponent>(
    ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
  )?.size;
  return entitySize ? `${entitySize.width}x${entitySize.depth}` : null;
};
const getEnitiesWithProductType = (entities: Entity[], productType: ProductType) => {
  return entities.filter(
    entity =>
      entity.getComponent<ProductInfoComponent>(ProductInfoComponent.id)?.productType ===
      productType
  );
};
export const matchInteriorsToSections = (products: Product[], entitiesInScene: Entity[]) => {
  const sectionsInScene = getEnitiesWithProductType(entitiesInScene, ProductType.BROR_SECTION);
  const sectionSizesInScene = sectionsInScene
    .map(section => getEntitySizeString(section))
    .filter(Boolean) as string[];

  return products.filter(product => {
    const interiorSize = `${product.communicatedDimensions.width}x${product.communicatedDimensions.depth}`;
    if (
      [
        ProductType.BROR_SHELF_METAL_BLACK,
        ProductType.BROR_PEGBOARD_SET,
        ProductType.BROR_RAIL,
        ProductType.BROR_SHELF_GREEN_PINE,
        ProductType.BROR_DRAWER_METAL_BLACK
      ].includes(product.type)
    ) {
      return sectionSizesInScene.includes(interiorSize);
    }
    return true;
  });
};

const hasOtherProductsOfMatchingWidthAndDepth = (productTypesToMatch: ProductType[]) => (
  products: Product[]
) => {
  const productsInMarket = getMarketProducts(store.getState());
  const candidateProducts = productsInMarket.filter(p => productTypesToMatch.includes(p.type));
  const matchingProducts = products.filter(p =>
    candidateProducts.some(
      c =>
        c.communicatedDimensions.width === p.communicatedDimensions.width &&
        c.communicatedDimensions.depth === p.communicatedDimensions.depth
    )
  );

  return matchingProducts;
};

export const hasInsertsOfMatchingWidthAndDepth = hasOtherProductsOfMatchingWidthAndDepth([
  ProductType.BROR_SHELF_METAL_BLACK,
  ProductType.BROR_FOUR_PACK_SHELF,
  ProductType.BROR_SHELF_BLACK_PINE,
  ProductType.BROR_SHELF_GREEN_PINE
]);
